import { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "./EventShowcase.css";

import admission from "../../utils/images/events/admission.PNG";
import greenFarewell from "../../utils/images/events/Green-Farewell.jpeg";
import healthAwareness from "../../utils/images/events/health-awareness.jpeg";
import studentCouncil from "../../utils/images/events/student-council-election.jpeg";
import children1 from "../../utils/images/School_Children1.jpg";
import children2 from "../../utils/images/School_Children2.jpg";
import children3 from "../../utils/images/School_Children3.jpg";

import lab1 from "../../utils/images/atal-tinkering-lab2.jpeg";
import lab2 from "../../utils/images/School_Sport4.jpg";
import lab3 from "../../utils/images/sessions.jpeg";
import scienceLab from "../../utils/images/events/sience-lab.jpeg";

import sport1 from "../../utils/images/sports.jpeg";
import sport2 from "../../utils/images/School_Sport2.jpg";
import sport3 from "../../utils/images/School_Sport1.jpg";
import sport4 from "../../utils/images/School_Sport3.jpg";

import holiActivity from "../../utils/images/events/holi-activity.jpeg";
import student1 from "../../utils/images/academics.PNG";
import student3 from "../../utils/images/School_Students.jpg";
import student2 from "../../utils/images/School_Students1.jpg";

// Image to text mapping
const imageTextMap = {
  [admission]: {
    title: "Admission Open",
    description:
      "Join our school and be part of an inclusive learning community dedicated to excellence and growth.",
  },
  [greenFarewell]: {
    title: "Green Farewell",
    description:
      "Celebrating our outgoing students with eco-friendly initiatives and memorable moments.",
  },
  [studentCouncil]: {
    title: "Student Council Election",
    description:
      "Empowering students to lead, innovate, and represent their voices in school governance.",
  },
};

const events = [
  {
    images: [admission, greenFarewell, studentCouncil, healthAwareness],
  },

  {
    title: "Student Activities",
    images: [holiActivity, children1, children2, children3],
  },

  {
    title: "Labs & Sessions",
    images: [lab1, scienceLab, lab2, lab3],
  },

  {
    title: "Sports Events",
    images: [sport1, sport2, sport3, sport4],
  },

  {
    title: "Academic Excellence",
    images: [student1, student2, student3],
  },
];

function EventShowcase() {
  const [currentSlides, setCurrentSlides] = useState(events.map(() => 0));

  const [open, setOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  useEffect(() => {
    if (open) return;

    const timer = setInterval(() => {
      setCurrentSlides((prev) =>
        prev.map((slide, index) => {
          const total = events[index].images.length;
          return (slide + 1) % total;
        }),
      );
    }, 3000);

    return () => clearInterval(timer);
  }, [open]);

  const openGallery = (eventIndex) => {
    setSelectedEvent(eventIndex);
    setLightboxIndex(0);
    setOpen(true);
  };

  return (
    <section className="event-section">
      <div className="container">
        <div className="text-center mb-3">
          <h3 className="event-heading">Highlights From School Activities</h3>

          <p className="">
            Explore memorable moments from our academic, cultural and sports
            events.
          </p>
        </div>

        <div className="event-grid">
          {/* Left Big Card - SPECIAL CARD */}
          <div className="featured-event" onClick={() => openGallery(0)}>
            <img
              src={events[0].images[currentSlides[0]]}
              alt=""
              className="featured-image"
            />

            <div className="featured-overlay">
              <p>{events[0].images.length} Photos</p>
              <h3>{events[0].title}</h3>
              <p>{events[0].description}</p>
            </div>
          </div>

          {/* Right Grid */}
          <div className="side-grid">
            {events.slice(1).map((event, index) => {
              const actualIndex = index + 1;

              return (
                <div
                  key={index}
                  className="event-card"
                  onClick={() => openGallery(actualIndex)}
                >
                  <img
                    src={event.images[currentSlides[actualIndex]]}
                    alt=""
                    className="event-card-image"
                  />

                  <div className="event-card-overlay">
                    <h5>{event.title}</h5>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {selectedEvent !== null && (
          <Lightbox
            open={open}
            close={() => setOpen(false)}
            index={lightboxIndex}
            slides={events[selectedEvent].images.map((img) => ({
              src: img,
            }))}
            on={{
              view: ({ index }) => setLightboxIndex(index),
            }}
          />
        )}
      </div>
    </section>
  );
}

export default EventShowcase;
